import $ from 'jquery';

const LoadMore = {

	/**
	 * Load more elements.
	 *
	 * @type {object}
	 */
	$els: {},

	/**
	 * Initialize.
	 *
	 * @returns {void}
	 */
	init() {
		this.$els = $( '.load-more' );
		this.$els.on( 'click', this.loadMore );
	},

	/**
	 * Load more podcasts.
	 *
	 * @returns {void}
	 */
	loadMore( e ) {
		const targetId = $(e.target).attr( 'id' );
		const offset   = $(e.target).data( 'offset' );
		const per_page = $(e.target).data( 'posts-per-page' );
		
		const $target  = $( `[data-target="#${ targetId }"]` );
		const tax      = $target.data( 'tax' );
		const cat      = $target.data( 'cat' );
		const sort     = $target.data( 'sort' );
		
		let page       = $(e.target).data( 'page' );
		page           = ( undefined === page ) ? 0 : page;

		let query = {
			action: 'cc_load_more',
			method: targetId,
			tax: tax,
			cat: cat,
			offset: offset,
			per_page: per_page,
			page: page,
			security: curiousSettings.ajaxNonce
		};

		if ( sort && sort.length > 1 ) {			
			query.sort_by    = sort[0];
			query.sort_order = sort[1];
		}

		$.get(curiousSettings.ajaxUrl, query)
			.done( function( data ) {
				$target.append( data );
				$(e.target).removeClass('c-button--loading');
				$(e.target).data( 'page', page + 1 );

				// check if this is the last page
				if ( $target.find('.last-page').length ) {
					$(e.target).hide();
				}
			});

		$(e.target).addClass('c-button--loading');
	}

};

export default LoadMore;